import {
    ComponentFactory
} from '@angular/core';

export class ColumnGroup {
    constructor(
        public Name: string,
        public Header: string,
        public HeaderTextAlign?: string) {
        this.HeaderTextAlign = HeaderTextAlign || this.DefaultHeaderTextAlign;
    }

    get DefaultHeaderTextAlign(): string {
        return "center";
    }
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/objects/request/column-group.ts